/* global listUsersUrl updateProjectActivityByKeyUrl fetchProjectActivitiesUrl viewProjectActivityDetailsUrl dataUrl */
/* global minDate maxDate canManage activityTypes sourceCategories fetchProjectGanttChartUrl fetchProjectGanttChartLinksUrl moveProjectGanttChartUrl fetchProjectRoadmapUrl fetchProjectRoadmapMilestoneUrl saveProjectRoadmapSettingsUrl downloadProjectRoadmapPdfUrl roadmapSettings roadmapUserId exportProjectPlanUrl importProjectPlanUrl deleteProjectPlanUrl */
/* global fetchProjectActivityUrl updateProjectActivityUrl storeProjectActivityUrl */
/* global fetchProjectActivityActionsUrl fetchDepartmentsOptionsUrl fetchVenuesOptionsUrl */
/* global storeProjectCategoryUrl updateProjectCategoryUrl updateProjectCategoryOwnerUrl updateProjectActivityOwnerUrl categoryStatuses activityCompletenessStatuses */
/* global fetchProjectResourcesUrl fetchProjectActivityResourcesUrl allocateProjectResourcesUrl */
/* global fetchProjectActivityDependenciesUrl searchProjectActivityDependencyCandidatesUrl searchProjectCategoryDependencyCandidatesUrl dependencyTypes */
/* global eventId eventSlug actionSummaryUrl actionSummaryExportUrl */
/* global updateProjectOwnerUrl projectOwner canEditProjectOwner */
/* global projectPlanSavedFilters saveProjectPlanFiltersUrl fetchProjectPlanScheduleUrl saveProjectPlanScheduleTargetUrl projectPlanScheduleTargetId */

import React, { memo, useCallback, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ProjectDashboardIndex from '../project_dashboard/ProjectDashboardIndex';

import ActionSummaryIndex from './action_summary/ActionSummaryIndex';
import ProjectPlanPage from './ProjectPlanPage';
import RoadmapIndex from './roadmap/RoadmapIndex';

import Tabs, { RenderStrategyAlways, RenderStrategyOnVisit } from 'CommonComponents/Tabs';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';
import { ProjectPeriodProvider } from 'Context/project_plan/ProjectPeriodContext';
import { ProjectPlanProvider } from 'Context/project_plan/ProjectPlanContext';
import { ProjectRoadmapProvider } from 'Context/project_plan/ProjectRoadmapContext';
import { UsersProvider } from 'Context/UsersContext';

const TAB_DASHBOARD = 'dashboard';
const TAB_PLAN = 'plan';
const TAB_SUMMARY = 'summary';
const TAB_ROADMAP = 'roadmap';

const TAB_IDS = [TAB_DASHBOARD, TAB_PLAN, TAB_SUMMARY, TAB_ROADMAP];

// `#dashboard`, `#plan`, `#summary` and `#roadmap` deep-link to their tab.
const tabFromHash = () => {
    const hash = window.location.hash.replace('#', '');

    return TAB_IDS.includes(hash) ? hash : TAB_DASHBOARD;
};

const ProjectPlanIndex = memo(function ProjectPlanIndex() {
    const [activeTab, setActiveTab] = useState(tabFromHash);

    const activateTab = useCallback((tabId) => {
        setActiveTab(tabId);
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${tabId}`);
    }, []);

    const goToPlan = useCallback(() => activateTab(TAB_PLAN), [activateTab]);

    const tabs = useMemo(
        () => [
            {
                id: TAB_DASHBOARD,
                title: $t('Dashboard'),
                renderStrategy: RenderStrategyAlways,
                content: () => (
                    <ProjectDashboardIndex
                        fetchProjectActivitiesUrl={fetchProjectActivitiesUrl}
                        viewProjectActivityDetailsUrl={viewProjectActivityDetailsUrl}
                        updateActivityUrl={updateProjectActivityByKeyUrl}
                        dataUrl={dataUrl}
                        minDate={minDate}
                        maxDate={maxDate}
                        canManage={canManage}
                        importProjectPlanUrl={importProjectPlanUrl}
                        onAddActivity={goToPlan}
                    />
                ),
            },
            {
                id: TAB_PLAN,
                title: $t('Project Plan'),
                renderStrategy: RenderStrategyOnVisit,
                content: () => (
                    <ProjectPeriodProvider minDate={minDate} maxDate={maxDate} eventSlug={eventSlug}>
                        <ProjectPlanProvider
                            fetchProjectGanttChartUrl={fetchProjectGanttChartUrl}
                            fetchProjectGanttChartLinksUrl={fetchProjectGanttChartLinksUrl}
                            moveProjectGanttChartUrl={moveProjectGanttChartUrl}
                            updateProjectCategoryOwnerUrl={updateProjectCategoryOwnerUrl}
                            updateProjectActivityOwnerUrl={updateProjectActivityOwnerUrl}
                            deleteProjectPlanUrl={deleteProjectPlanUrl}
                            fetchProjectResourcesUrl={fetchProjectResourcesUrl}
                            fetchProjectActivityResourcesUrl={fetchProjectActivityResourcesUrl}
                            allocateProjectResourcesUrl={allocateProjectResourcesUrl}
                            fetchProjectActivityDependenciesUrl={fetchProjectActivityDependenciesUrl}
                            searchProjectActivityDependencyCandidatesUrl={searchProjectActivityDependencyCandidatesUrl}
                            searchProjectCategoryDependencyCandidatesUrl={searchProjectCategoryDependencyCandidatesUrl}
                            dependencyTypes={dependencyTypes}
                            statuses={categoryStatuses}
                            completenessStatuses={activityCompletenessStatuses}
                            canManage={canManage}
                            activityTypes={activityTypes}
                            sourceCategories={sourceCategories}
                            savedFilters={projectPlanSavedFilters}
                            saveFiltersUrl={saveProjectPlanFiltersUrl}
                            fetchScheduleUrl={fetchProjectPlanScheduleUrl}
                            saveScheduleTargetUrl={saveProjectPlanScheduleTargetUrl}
                            savedScheduleTargetId={projectPlanScheduleTargetId}
                        >
                            <ProjectPlanPage
                                exportProjectPlanUrl={exportProjectPlanUrl}
                                importProjectPlanUrl={importProjectPlanUrl}
                                storeProjectCategoryUrl={storeProjectCategoryUrl}
                                updateProjectCategoryUrl={updateProjectCategoryUrl}
                                fetchProjectActivityUrl={fetchProjectActivityUrl}
                                storeProjectActivityUrl={storeProjectActivityUrl}
                                updateProjectActivityUrl={updateProjectActivityUrl}
                                fetchProjectActivityActionsUrl={fetchProjectActivityActionsUrl}
                                fetchDepartmentsOptionsUrl={fetchDepartmentsOptionsUrl}
                                fetchVenuesOptionsUrl={fetchVenuesOptionsUrl}
                                updateProjectOwnerUrl={updateProjectOwnerUrl}
                                projectOwner={projectOwner}
                                canEditProjectOwner={canEditProjectOwner}
                            />
                        </ProjectPlanProvider>
                    </ProjectPeriodProvider>
                ),
            },
            {
                id: TAB_SUMMARY,
                title: $t('Actions Summary'),
                renderStrategy: RenderStrategyAlways,
                content: () => (
                    <ActionSummaryIndex
                        actionSummaryUrl={actionSummaryUrl}
                        actionSummaryExportUrl={actionSummaryExportUrl}
                        isActive={activeTab === TAB_SUMMARY}
                        onGoToProjectPlan={goToPlan}
                    />
                ),
            },
            {
                id: TAB_ROADMAP,
                title: $t('Milestone Roadmap'),
                renderStrategy: RenderStrategyOnVisit,
                content: () => (
                    <ProjectRoadmapProvider
                        eventId={eventId}
                        userId={roadmapUserId}
                        serverSettings={roadmapSettings}
                        fetchUrl={fetchProjectRoadmapUrl}
                        milestoneUrl={fetchProjectRoadmapMilestoneUrl}
                        saveUrl={saveProjectRoadmapSettingsUrl}
                        downloadPdfUrl={downloadProjectRoadmapPdfUrl}
                    >
                        <RoadmapIndex />
                    </ProjectRoadmapProvider>
                ),
            },
        ],
        [activeTab, goToPlan],
    );

    return <Tabs tabs={tabs} activeTab={activeTab} onTabActivate={activateTab} maxScreenHeight />;
});

if (document.getElementById('ProjectPlan')) {
    var root = document.getElementById('ProjectPlan');
    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <UsersProvider fetchUrl={listUsersUrl}>
                    <ProjectPlanIndex />
                </UsersProvider>
            </ConfirmationModalProvider>
        </App>,
        root,
    );
}

export default ProjectPlanIndex;
